import { Component, OnInit } from '@angular/core';
import {CommonService} from '../../../../services/common.service';
import {ToastMessagesService} from '../../../../services/toast-messages.service';
import {ConfirmDialogComponent} from '../../../shared/confirm-dialog/confirm-dialog.component';
import {MatDialog} from '@angular/material/dialog';
interface Level {
  id: number;
  description: string;
}
@Component({
  selector: 'app-activities-levels-dialog',
  templateUrl: './activities-levels-dialog.component.html',
  styleUrls: ['./activities-levels-dialog.component.scss']
})
export class ActivitiesLevelsDialogComponent implements OnInit {
  newLevel: any;
  loadingLevels: boolean;
  levels: Level[];

  constructor(public commonService: CommonService,
              public dialog: MatDialog,
              public toastMessagesService: ToastMessagesService) {
    this.loadingLevels = false;
    this.newLevel = '';
  }

  async ngOnInit() {
    await this.initLevels();
  }

  async initLevels() {
    this.loadingLevels = true;
    try {
      const questionsRequest = await this.commonService.getList('activities/levels');
      this.levels = questionsRequest.object;
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    } finally {
      this.loadingLevels = false;
    }
  }

  async insertLevel() {
    const value = this.newLevel;
    if (value.trim() === '') {
      this.toastMessagesService.toastErrorMessage('Θα πρέπει να συμπληρώσετε την περιγραφή της δραστηριότητας');
      return;
    }

    try {
      await this.commonService.insertItem(`activities/levels`, {description: value});
      this.toastMessagesService.toastMessages('Η εισαγωγή ολοκληρώθηκε με επιτυχία');
      await this.initLevels();
      this.clearNewLevel();
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  confirmDeletion(level: Level) {
    const deleteDialog = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'Διαγραφή Δραστηριότητας',
        message: 'Είστε σίγουροι ότι θέλετε να διαγράψετε το επίπεδο της δραστηριότητας. Προσοχή θα διαγραφούν και όλες οι αναθέσεις που έχουν γίνει?',
        icon: 'delete'
      }
    });

    deleteDialog.afterClosed().subscribe(async (result) => {
      if (result) {
        await this.deleteLevel(level);
      }
    });
  }

  async deleteLevel(level: Level) {
    try {
      await this.commonService.deleteItem(`activities/levels?id=${level.id}`);
      this.toastMessagesService.toastMessages('Η διαγραφή ολοκληρώθηκε με επιτυχία');
      await this.initLevels();
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }
  clearNewLevel() {
    this.newLevel = '';
  }
}
